module.exports = __webpack_public_path__ + "img/d5b9485.png";